import React, {useRef} from "react";
import {useEffect} from "react";
import {Button, Card, Col, DatePicker, Form, Row} from "antd";
import {t} from "i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import Helper from "../../../core/Helper";
import CashRegisterSelectList from "../../cash-register/CashRegisterSelectList";
import {useUser} from "../../../core/context/UserContext";

export default function ExpenseFilter()
{
    const {onFilterPageSort, queryModel} = useDataGrid();
    const {user} = useUser()
    const formRef = useRef();

    useEffect(() => {
        formRef.current.setFieldsValue(queryModel.filter)
    }, [queryModel.updateKey])

    const onFinish = async (formData) => {
        onFilterPageSort({filter: formData})
    }

    return (
        <Form
            size={'small'}
            layout={'vertical'}
            ref={formRef}
            onFinish={onFinish}
            initialValues={{
                cashRegisterId: -1
            }}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
                <Form.Item
                    style={{margin: 0}}
                    name={'startDate'}
                >
                    <DatePicker
                        locale={Helper.Date.getLocale()}
                        format={'DD/MM/yyyy'}
                        placeholder={t('Start Date')}
                    />
                </Form.Item>
                <Form.Item
                    style={{margin: 0}}
                    name={'endDate'}
                >
                    <DatePicker
                        locale={Helper.Date.getLocale()}
                        format={'DD/MM/yyyy'}
                        placeholder={t('End Date')}
                    />
                </Form.Item>
                <Form.Item
                    style={{margin: 0}}
                    name={'cashRegisterId'}
                >
                    <CashRegisterSelectList
                        allOption={true}
                        style={{width: 200}}
                        placeholder={t('Cash Register')}
                        all={false}
                    />
                </Form.Item>
                <Form.Item
                    style={{margin: 0}}
                >
                    <Button htmlType={'submit'}>
                        {t('Search')}
                    </Button>
                </Form.Item>
            </div>
        </Form>
    )
}